<form (ngSubmit)="onSubmit()" [formGroup]="formGroup()">
  @if (isErrorSummaryDisplayed()) {
    <govuk-error-summary [form]="formGroup()" />
  }

  <netz-page-heading [caption]="caption()">{{ heading() }}</netz-page-heading>

  <ng-content />

  @if (!hideSubmit()) {
    <button netzPendingButton govukButton type="submit">{{ submitText() }}</button>
  }

  @if (showCancelLink()) {
    <div>
      <a class="govuk-link" [routerLink]="cancelLinkPath()">Cancel</a>
    </div>
  }
</form>
